/* Shipping protection tick box (snippets/nt-protect.liquid, Dakota via Luke 15/10/2026). OPT-IN: nothing is added until they tick it.
   Keeps the protection line right after ANY cart change (theme drawer, cart page, "Complete your bed", apps): one only, qty 1,
   the right price tier for the order value, and removed when nothing that ships is left. Re-checks once more before checkout. */
(() => {
  const P = window.NTPROT; if (!P || window.__ntProt) return; window.__ntProt = true;
  const J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const of = window.fetch.bind(window);
  let busy = false, tm;
  const isP = (i) => i.product_id === P.pid;
  const cart = () => of(theme.routes.cart_url + '.js', { headers: J }).then((r) => r.json());
  const want = (st) => {
    const g = st.items.filter((i) => !isP(i) && !i.gift_card);
    if (!g.length) return null;
    const v = g.reduce((a, i) => a + i.final_line_price, 0);
    return P.tiers.filter((t) => v >= t.min).pop() || P.tiers[0];
  };
  const update = (up) => of(theme.routes.cart_update_url + '.js', { method: 'POST', headers: J, body: JSON.stringify({ updates: up }) });
  /* redraw the drawer + bubble (app.js CartDrawer) and the /cart page (cart.js Cart) from fresh section HTML */
  const redraw = () => document.dispatchEvent(new CustomEvent('cart:refresh'));
  /* returns true when it changed the cart */
  async function fix() {
    if (busy) return false;
    const st = await cart(), lines = st.items.filter(isP);
    if (!lines.length) return false;
    const w = want(st);
    if (w && lines.length === 1 && lines[0].variant_id === w.id && lines[0].quantity === 1) return false;
    const up = {}; lines.forEach((l) => { up[l.variant_id] = 0; }); if (w) up[w.id] = 1;
    busy = true; try { await update(up); } finally { busy = false; }
    return true;
  }
  async function set(on) {
    const st = await cart(), up = {};
    st.items.filter(isP).forEach((l) => { up[l.variant_id] = 0; });
    const w = want(st); if (on && w) up[w.id] = 1;
    busy = true; try { await update(up); } finally { busy = false; }
  }
  document.addEventListener('change', (e) => {
    const b = e.target.closest && e.target.closest('[data-nt-prot]'); if (!b) return;
    e.stopPropagation();
    document.querySelectorAll('[data-nt-prot]').forEach((x) => { x.disabled = true; });
    set(b.checked).catch(() => {}).then(redraw);
  }, true);
  /* cart changes made by anything else → re-check the protection line shortly after */
  window.fetch = function (u) {
    const out = of.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update)(\.js)?\b/.test(String((u && u.url) || u)))
      out.then(() => { clearTimeout(tm); tm = setTimeout(() => fix().then((ch) => ch && redraw()).catch(() => {}), 400); }, () => {});
    return out;
  };
  /* last check before checkout (drawer + cart page buttons) */
  document.addEventListener('click', (e) => {
    const co = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!co || co.dataset.ntok) return;
    e.preventDefault(); e.stopPropagation();
    fix().catch(() => {}).then(() => { co.dataset.ntok = 1; co.click(); setTimeout(() => { delete co.dataset.ntok; }, 4000); });
  }, true);
  /* on load: a cart left with protection alone, or on the wrong tier, gets fixed */
  fix().then((ch) => ch && redraw()).catch(() => {});
})();
